module.exports = __webpack_public_path__ + "img/limit1cn.7a884041.png";